module.exports = __webpack_public_path__ + "img/BestEmployee.9798eba3.svg";